import { render, staticRenderFns } from "./TaxonomyPropagateTo.vue?vue&type=template&id=9ef475b6&"
import script from "./TaxonomyPropagateTo.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyPropagateTo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports